import { useIntl } from 'react-intl';
import { Tooltip } from '@rossum/ui/material';
import { GridRenderCellParams } from '@rossum/ui/x-data-grid-pro';
import { TransformedOperation } from '../helpers';

export const RenderDate = ({
  value,
}: GridRenderCellParams<TransformedOperation, Date>) => {
  const intl = useIntl();

  if (!value) return null;

  const formattedDate = intl.formatDate(value, { dateStyle: 'medium' });
  const formattedDateTime = intl.formatDate(value, {
    dateStyle: 'full',
    timeStyle: 'medium',
  });

  return (
    <Tooltip title={formattedDateTime} placement="bottom">
      <span>{formattedDate}</span>
    </Tooltip>
  );
};
